module.exports = __webpack_public_path__ + "img/calendar.4acd00e3.svg";